export default class ReviewsStateStatistics {
	numberOfReviews: number = 0;
	repliedCount: number = 0;
	positiveSentimentCount: number = 0;
	negativeSentimentCount: number = 0;
	neutralSentimentCount: number = 0;
	totalImpact: number = 0;
	score: number = 0;
	responseRate: number = 0;
	positivityRate: number = 0;

	constructor(data: Partial<ReviewsStateStatistics> = {}) {
		Object.assign(this, data);
	}

	get totalMentions(): number {
		return this.positiveSentimentCount + this.negativeSentimentCount;
	}
}
